import { FC, useState } from 'react';
import './InteractiveTour.scss';
import Intro from './Intro/Intro';
import Slide from './Slide/Slide';
import { InteractiveTourProps } from './InteractiveTourProps';
import { InteractiveTourContext } from './InteractiveTourContext';

const InteractiveTour: FC<InteractiveTourProps> = ({ content }) => {
  const [currentSlide, setCurrentSlide] = useState(content.slides.items[0].id);
  const [showIntro, setShowIntro] = useState(content.intro.active || false);
  const [hasIntro] = useState(content.intro.active || false);

  return (
    <InteractiveTourContext.Provider
      value={{
        currentSlide,
        setCurrentSlide,
        showIntro,
        setShowIntro,
        hasIntro,
      }}
    >
      <div className="bx--row">
        <div className="bx--col-lg-4 interactive-tour__aside-title widget-styles">
          <h3>{content.title}</h3>
          <p>{content?.description}</p>
        </div>
      </div>
      {showIntro ? (
        <Intro content={content.intro} />
      ) : (
        <Slide content={content} />
      )}
    </InteractiveTourContext.Provider>
  );
};

export default InteractiveTour;
